import { render, staticRenderFns } from "./ManageDepartmentForm.vue?vue&type=template&id=3084aed8&"
import script from "./ManageDepartmentForm.vue?vue&type=script&lang=js&"
export * from "./ManageDepartmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports